import React from 'react';
import {
  Col, Badge,
} from 'reactstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
// import DeleteIcon from 'mdi-react/DeleteIcon';
import { getImgByTitle, getImgCryptoByTitle } from '../../../utils/functions';

const idLocale = require('moment/locale/fr');

moment.locale('fr', idLocale);

const addDefaultSrc = (ev) => {
  ev.target.src = `${process.env.PUBLIC_URL}/img/logo/default.png`;
};

const renderImg = (data) => {
  let img = 'default';
  const {
    category, value, title, subcategory, isPlanner,
  } = data;
  if (value) {
    img = value;
  } else if (title) {
    let folderPath = subcategory === 'crypto_currency' ? '/crypto/' : '/logo/';
    let imgName = subcategory === 'crypto_currency' ? getImgCryptoByTitle(title) : getImgByTitle(title);
    if (['estate', 'bank', 'art', 'other_investment', 'art', 'item', 'intellectual', 'shop', 'company', 'contract'].includes(category)) {
      imgName = category;
      folderPath = '/';
    }
    img = `${folderPath + imgName}`;
  }
  if (isPlanner) {
    return <img onError={addDefaultSrc} style={{ marginRight: 0, borderRadius: 0 }} className="topbar__avatar-img bigger" src={`${process.env.PUBLIC_URL}/img/${subcategory}.svg`} alt="logo_img" />;
  }
  return (
    <img onError={addDefaultSrc} style={{ marginRight: 0, borderRadius: 0 }} className="topbar__avatar-img bigger" src={`${process.env.PUBLIC_URL}/img/${img}.png`} alt="logo_img" />
  );
};

const AssetModalLeft = ({
  data,
}) => (
  <Col md="4" className="darkBack pt-20 pb-40 pl-12 pr-12">
    <div style={{ marginTop: 40, textAlign: 'center' }}>
      <div className="whiteCirclePhoto">
        {renderImg(data)}
      </div>
      <h3 className="bold-text text-white mb-40">{data.title}</h3>
      <p className="text-white lh10 fs12 fw-500">Créé le : {moment(data.created_at).format('L')}</p>
      <p className="text-white lh10 fs12 fw-500">Status : <Badge color="success">Complet</Badge></p>
    </div>
  </Col>
);

AssetModalLeft.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default AssetModalLeft;
